module.exports = __webpack_public_path__ + "static/media/video-starting-convo-es.6b79ccf3.vtt";